import SaralLoader from '../../../assets/icons/saral-loader.gif';

export default function SaralLoaderImage({ width = '80.5' }: { width?: string }) {
  return <img alt="saral-loader" src={SaralLoader} width={width} />;
}
